import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { IPageLayoutCardData } from '../fi-site-design-brand-editor.component';

@Component({
    selector: 'fi-brand-editor-page-layout-card',
    templateUrl: './fi-brand-editor-page-layout-card.component.html',
    styleUrls: ['./fi-brand-editor-page-layout-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-brand-editor-page-layout-card' },
    standalone: false,
})
export class FiBrandEditorPageLayoutCardComponent implements OnInit {
    @Input() cardData: IPageLayoutCardData;

    constructor(private stateService: FiStateService) {}

    ngOnInit(): void {}

    goToPageLayoutEditor() {
        this.stateService.go(this.cardData.sref, this.cardData.srefParams);
    }
}
